const { dateService } = require('../../../services/dateService');
const { getContentPublishDate } = require('./getContentPublishDate');
const { getContentModificationDate } = require('./getContentModificationDate');

const getContentDateData = content => {
  const timestamp = getContentPublishDate(content) * 1000;
  const updated = getContentModificationDate(content) * 1000;
  const mustShowUpdated = updated - timestamp > 60 * 60 * 1000; // 1 hour
  if (!content.isEverGreen && !content.hideDate) {
    const dateData = mustShowUpdated
      ? {
          published: `${dateService.format(timestamp, 'article_date', {
            useSiteTimezone: true
          })}`,
          updated: `${dateService.format(updated, 'article_date', {
            useSiteTimezone: true
          })}`
        }
      : {
          published: `${dateService.format(timestamp, 'article_date', {
            useSiteTimezone: true
          })}`
        };
    return dateData;
  }
  return null;
};

module.exports = {
  getContentPublishDate,
  getContentModificationDate,
  getContentDateData
};
